import React from 'react';
import {
	Input,
	Select,
	Form,
	Modal,
	DatePicker,
	Upload,
	message,
	Button,
	Icon,
	Col,
	Row,
	Drawer,
	Descriptions,
	Badge,
	Statistic,
	Tag
} from 'antd';
import moment from 'moment';

const DerWareHouseListDetail =(props)=>{
	
	const {onCancel,visible,item} =props
	
	let width = window.innerWidth <768 ? window.innerWidth*0.8 :window.innerWidth*0.35
	return (

	<Drawer   title={item.partnerOrderNo?<span>单号:{item.partnerOrderNo}</span>:<span>无订单号</span>}     placement="right"      closable={false}      onClose={onCancel}    visible={visible}  width={width}  >
	<Descriptions title="出库申请详情" layout="vertical" bordered>

		<Descriptions.Item label="借据号">{item.iouNo}</Descriptions.Item>
		<Descriptions.Item label="需还款总金额"><Statistic value={item.repayPrin/100} precision={2} valueStyle ={{fontSize:'15px',fontWeight:'bold'}}/></Descriptions.Item>
		<Descriptions.Item label="还款金额"><Statistic value={item.repaymentAmount/100} precision={2} valueStyle ={{fontSize:'15px',fontWeight:'bold'}}/></Descriptions.Item>



	  </Descriptions><br/>
	  
	  	

      </Drawer>
	
	)

}


export default DerWareHouseListDetail;
